// extracted by css-extract-rspack-plugin
export default {"container":"_e4c8560","title":"_480ad8e7","description":"_71c488c1","mobileBreak":"_d50d378"};